export default __webpack_public_path__ + "static/media/step-finish.0dbbbaa5.svg";